import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {

  private messageSource = new BehaviorSubject('default message');

  private dataStringSource = new BehaviorSubject('');

  dataString = this.dataStringSource.asObservable();


  private menuList: any = []
  currentMessage = this.messageSource.asObservable();

  private popupState = new BehaviorSubject<boolean>(false);

  popupState$ = this.popupState.asObservable();

  private supportPopupMessageSource = new BehaviorSubject<string>('');

  supportPopupMessage$ = this.supportPopupMessageSource.asObservable();

 

  constructor() { }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  insertData(data: string) {
    this.dataStringSource.next(data)
  }

  setSupportPopupMessage(message: string) {
    this.supportPopupMessageSource.next(message ? message : '');
  }

  getSupportPopupMessage(): string {
    return this.supportPopupMessageSource.getValue();
  }

  open(value:boolean) {
    this.popupState.next(value);
  }

}


// WEBPACK FOOTER //
// /codebuild/output/src2927200756/src/src/app/shared/services/data-sharing/data.service.ts